import { BsBehance, BsGithub, BsLinkedin, BsInstagram, BsDribbble, } from "react-icons/bs";

const Footer = () => {
  return (
    <div>
      <footer className="w-full mt-40 px-2 md:px-2 lg:px-20 bg-dark flex flex-col justify-items-center ">
        {/* newsletter */}
        <div className="newsletter flex flex-col md:flex-row h-40 mx-20 w-full md:w-95 bg-primary items-center place-self-center rounded-lg -translate-y-1/2">
          <div className="left flex-1 flex flex-col items-center justify-center md:pl-2">
            <h1 className="text-lg md:text-lg font-semibold lg:text-2xl text-white font-Poppins lg:font-bold drop-shadow-md">
              Want product news and offers sale?
            </h1>
            <p className="text-base md:text-lg text-white font-Poppins font-medium drop-shadow-md">
              Sing up our newsletter to stay up to date.
            </p>
          </div>
          <div className="right flex-1 flex items-center justify-center gap-2">
            <input
              className="w-2/4 md:w-3/5 text-base placeholder:text-slate-400 bg-white border border-slate-300 font-Poppins rounded p-3 shadow-sm focus:outline-none focus:border-sky-500 focus:ring-sky-500 focus:ring-1"
              type="email"
              name="email"
              placeholder="Enter your email"
            />
            <button
              className=" md:text-base text-white bg-secondary hover:bg-secondary-50 transition py-3 px-4 font-Poppins font-medium rounded"
              type="submit"
            >
              Notify me
            </button>
          </div>
        </div>

        <div className="container w-full flex flex-col items-center gap-6 -translate-y-1/2">
          <div className="links flex-1 flex gap-4 md:gap-8">
            <a
              className="text-base text-light hover:text-gray-500 transition font-Poppins font-normal drop-shadow-md"
              href="##"
            >
              Home
            </a>
            <a
              className="text-base text-light hover:text-gray-500 transition font-Poppins font-normal drop-shadow-md"
              href="##"
            >
              About
            </a>
            <a
              className="text-base text-light hover:text-gray-500 transition font-Poppins font-normal drop-shadow-md"
              href="##"
            >
              Contact
            </a>
            <a
              className="text-base text-light hover:text-gray-500 transition font-Poppins font-normal drop-shadow-md"
              href="##"
            >
              Categories
            </a>
          </div>
          <div className="social flex gap-6">
            <a href="##"><BsInstagram className="text-gray-500 hover:text-gray-600 transition text-lg" /></a> 
            <a href="##"><BsLinkedin className="text-gray-500 hover:text-gray-600 transition text-lg" /></a>
            <a href="##"><BsDribbble className="text-gray-500 hover:text-gray-600 transition text-lg" /></a>
            <a href="##"><BsBehance className="text-gray-500 hover:text-gray-600 transition text-lg" /></a>
            <a href="##"><BsGithub className="text-gray-500 hover:text-gray-600 transition text-lg" /></a>
          </div>
        </div>
        <div className="copyRight flex text-base p-4 text-light font-Poppins font-normal drop-shadow-md justify-center -translate-y-1/2">
          make with ❤️ by Ali Ameer
        </div>
      </footer>
    </div>
  );
};

export default Footer;
